import { sourceLabel } from '../lib/sources';

// Sizes are enumerated so Tailwind's JIT picks each class up.
const SIZE_CLS = {
    xs: 'w-3.5 h-3.5',
    sm: 'w-4 h-4',
    md: 'w-5 h-5',
    lg: 'w-6 h-6',
    xl: 'w-8 h-8',
    '2xl': 'w-14 h-14',
} as const;

// Renders the source-type logo shipped at `/sources/<type>.png`. Every
// visible source-logo site should use this so path/size/alt-text stay in one
// place. Omit `alt` for the source's human label; pass `''` for a decorative
// image (screen readers skip it).
export default function SourceLogo({ type, size, alt, className = '' }: {
    type: string;
    size: keyof typeof SIZE_CLS;
    alt?: string;
    className?: string;
}) {
    return (
        <img
            src={`/sources/${type}.png`}
            alt={alt ?? sourceLabel(type)}
            className={`${SIZE_CLS[size]} object-contain shrink-0${className ? ` ${className}` : ''}`}
        />
    );
}
